// extracted by mini-css-extract-plugin
export default {"card":"StudentNotebookCard_card__HtMQS","active":"StudentNotebookCard_active__+rQbM","isBelowK3":"StudentNotebookCard_isBelowK3__g+CWV","link":"StudentNotebookCard_link__moVSs"};